<template>
    <div class="slider">
        <div class="all-slide owl-item">

            <slider-item v-for="(slide, key) in slides" :key="key" :image="slide.image" :title=slide.title
                         :action="slide.action"
                         :description="slide.description"/>

        </div>
    </div>
</template>

<script>
    import SliderItem from './SliderItem';

    export default {
        name: 'Slider',
        components: {
            SliderItem
        },
        data () {
            return {
                slides: [
                    {
                        image: 'images/slider.jpg',
                        title: 'We Fight For Your Justice',
                        description: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
                        action: 'Kontakt aufnehmen'
                    },
                    {
                        image: 'images/slider.jpg',
                        title: 'We Fight For Your Justice',
                        description: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
                        action: 'Kontakt aufnehmen'
                    }
                ]
            };
        },
        methods: {}
    };
</script>
